import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import plant from "../../../assets/icons/climate.png";
import ai from "../../../assets/icons/ai.png";
import city from "../../../assets/icons/city.png";
import ecosystem from "../../../assets/icons/ecosystem.png";

const cardStyle = {
  bgcolor: "#fff",
  color: "#000",
};

const objectList = [
  {
    icon: plant,
    title: "Climate Resilience",
    subtitle:
      "Invest in climate-smart agriculture, renewable energy, and water management systems to protect livelihoods and reduce vulnerabilities to climate-related disasters.",
  },
  {
    icon: ai,
    title: "AI Innovation",
    subtitle:
      "Back AI-driven tools for education, healthcare, and urban planning, ensuring technological self-reliance and scalability across Africa.",
  },
  {
    icon: city,
    title: "Economic Innovations",
    subtitle:
      "Empower local leaders in secondary cities to enhance governance, infrastructure, and social entrepreneurship, transforming secondary cities into hubs of inclusive growth.",
  },
  {
    icon: ecosystem,
    title: "Innovation Ecosystems",
    subtitle:
      "Strengthen innovation ecosystems by funding African startups, innovation hubs, and mentoring programs to drive employment and economic inclusion.",
  },
];

const Opportunities = () => {
  return (
    <Box margin={{ xs: "35% 0%", sm: "10% 0% 10% 0%" }}>
      <Typography
        variant="h3"
        fontWeight={700}
        textAlign={"left"}
        paddingBottom={{ xs: "4%", sm: "2%" }}
        color={"#39484E"}
      >
        Funding Opportunities
      </Typography>
      <Typography
        variant="h6"
        fontWeight={400}
        textAlign={"left"}
        paddingBottom={{ xs: "4%", sm: "1%" }}
        color={"#000"}
      >
        AIR Fund offers a range of partnership levels tailored to philanthropic
        goals and areas of interest. Funders can choose to support:
      </Typography>
      <Grid container spacing={1}>
        {objectList.map((list, index) => {
          const { title, icon, subtitle } = list;
          return (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                margin={{ xs: "5% 0%", sm: "0%" }}
              >
                <Box
                  key={index}
                  component={Card}
                  height={"100%"}
                  padding={{ xs: "4% 4%", sm: "8% 8% 4% 8%" }}
                  margin={{ xs: "2% 0%", sm: "4% 0%" }}
                  borderRadius={"20px"}
                  display={"flex"}
                  flexDirection={"column"}
                  width={{ xs: "100%", sm: "100%" }}
                  sx={{ ...cardStyle }}
                >
                  <Box marginLeft={"2%"}>
                    {" "}
                    <Box
                      component="img"
                      height={{ xs: "64px", sm: "64px" }}
                      sx={{
                        objectFit: "cover",
                        overflow: "hidden",
                        width: "100%",
                      }}
                      src={icon}
                      alt={"icons"}
                    />
                  </Box>
                  <Typography
                    variant={"h5"}
                    fontWeight={700}
                    paddingTop={"6%"}
                    color={"#39484E"}
                  >
                    {title}
                  </Typography>
                  <Typography
                    variant={"body1"}
                    paddingTop={"6%"}
                    color={"#000"}
                  >
                    {subtitle}
                  </Typography>
                </Box>
              </Grid>
            </>
          );
        })}
      </Grid>
      <Typography
        variant="h6"
        fontWeight={400}
        textAlign={"left"}
        paddingTop={{ xs: "4%", sm: "2%" }}
        color={"#000"}
      >
        Funders can engage through one-time contributions or multi-year
        commitments, with options for co-funding initiatives or creating bespoke
        partnerships aligned with their priorities.
      </Typography>
    </Box>
  );
};

export default Opportunities;
